module.exports = __webpack_public_path__ + "09_long_yellow.079a5232.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/09_long_yellow.png
// module id = GkEO
// module chunks = 0